import { render } from "./AdditionalExpenseFormLink.vue?vue&type=template&id=1a367516"
import script from "./AdditionalExpenseFormLink.vue?vue&type=script&lang=js"
export * from "./AdditionalExpenseFormLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__